"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    fieldWrapper: {
        paddingTop: 14,
        paddingLeft: 15,
        backgroundColor: theme.grey9,
        border: `1px solid ${theme.grey6}`,
        borderRadius: 5
    },
    text: {
        color: theme.grey1,
        size: 16,
        weight: 600,
        margin: 10
    }
});
//# sourceMappingURL=arrayFieldTemplate.style.js.map